import { render } from "./car-four.vue?vue&type=template&id=18c1539e"
import script from "./car-four.vue?vue&type=script&lang=js"
export * from "./car-four.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__